var _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _rect2, _circle2, _rect3, _circle3, _rect4, _path7, _path8, _path9, _circle4, _rect5, _circle5, _rect6, _circle6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPacketingGuide(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5214 40.105L50.6381 48.4124V67.6147L35.5214 59.4435V40.105Z",
    fill: "#E8CA80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7744 32.751L35.3853 40.2412L50.7744 48.6848L65.6187 41.0584L50.7744 32.751Z",
    fill: "#CCAA66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4824 58.6266L50.6381 67.7512V48.685L65.4824 40.9224V58.6266Z",
    fill: "#F2DC94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2958 51.2725H73.2452",
    stroke: "#D59515",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5798 68.1597V76.8756C60.5798 78.1013 61.0701 80.5799 63.0312 80.6889H73.5176",
    stroke: "#D59515",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5798 33.8403V25.1244C60.5798 23.8987 61.0701 21.4201 63.0312 21.3111H73.5176",
    stroke: "#D59515",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5779,
    cy: 51.3407,
    r: 5.03794,
    fill: "#EEB94E",
    stroke: "#D59515",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8752,
    y: 49.502,
    width: 3.54086,
    height: 3.54086,
    fill: "#D38F05"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5779,
    cy: 80.2123,
    r: 5.03794,
    fill: "#EEB94E",
    stroke: "#D59515",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8752,
    y: 78.3735,
    width: 3.54086,
    height: 3.54086,
    fill: "#D38F05"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.3053,
    cy: 21.7879,
    r: 5.03794,
    fill: "#EEB94E",
    stroke: "#D59515",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.603,
    y: 19.9492,
    width: 3.54086,
    height: 3.54086,
    fill: "#D38F05"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0699 51.2725H29.1205",
    stroke: "#D59515",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7859 68.1597V76.8756C41.7859 78.1013 41.2956 80.5799 39.3345 80.6889H28.8481",
    stroke: "#D59515",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7859 33.8403V25.1244C41.7859 23.8987 41.2956 21.4201 39.3345 21.3111H28.8481",
    stroke: "#D59515",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 5.03794,
    transform: "matrix(-1 0 0 1 22.7879 51.3407)",
    fill: "#EEB94E",
    stroke: "#D59515",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.54086,
    height: 3.54086,
    transform: "matrix(-1 0 0 1 24.4902 49.502)",
    fill: "#D38F05"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 5.03794,
    transform: "matrix(-1 0 0 1 22.7879 80.2123)",
    fill: "#EEB94E",
    stroke: "#D59515",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.54086,
    height: 3.54086,
    transform: "matrix(-1 0 0 1 24.4902 78.3735)",
    fill: "#D38F05"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 5.03794,
    transform: "matrix(-1 0 0 1 23.0605 21.7879)",
    fill: "#EEB94E",
    stroke: "#D59515",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.54086,
    height: 3.54086,
    transform: "matrix(-1 0 0 1 24.7627 19.9492)",
    fill: "#D38F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacketingGuide);
export default __webpack_public_path__ + "static/media/packeting-guide.663ba80bcc200dbaf6a2ba83487e0811.svg";
export { ForwardRef as ReactComponent };